"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intellipick = void 0;
exports.intellipick = {
    purple100: "#2E087A",
    purple60: "#5029D3",
    purple40: "#6E50FF",
    purple20: "#AB9BF9",
    purple10: "#CFC6FD",
    purple0: "#F4F2FF",
    amber100: "#FFCB40",
    coral100: "#FF6666",
    mint100: "#2EC4B6",
    navy100: "#031D44",
    green100: "#31B32E",
    green10: "#E7F9E7",
    blue100: "#095CD7",
    blue10: "#E2EDFE",
    yellow100: "#DBA000",
    yellow10: "#FFF5DB",
    orange100: "#FF7005",
    orange10: "#FFF0E5",
    red100: "#FF3E3E",
    red80: "#FF6666",
    red10: "#FFEBEB",
};
//# sourceMappingURL=intellipick.js.map